import { toLowerCaseString } from './toLowerCaseString';

export const convertPoints = (value, fixed) => {
  const factor = 10 ** fixed;
  return Math.floor(value * factor) / factor;
};

export const convertBalance = (value, fixed, currency) => {
  return {
    points: convertPoints(value, fixed),
    currency: toLowerCaseString(currency),
  };
}

export const convertNumberToStrCurrency = (value, fixed) => {
  return value.toLocaleString('pt-br', {
    minimumFractionDigits: fixed,
    maximumFractionDigits: fixed
  })
}

export const convertNumberToStringCurrency = (val) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val)
}

export const convertPriceToPoints = (conversionRate, decimalPlaces, price) => {
  const numericPrice = parseFloat(price.toString().replace(',', '.'));

  if (isNaN(numericPrice)) {
    throw new Error("O valor de 'price' deve ser um número válido.");
  }

  const multiplier = Math.pow(10, decimalPlaces);
  return decimalPlaces === 0
    ? Math.ceil(numericPrice * conversionRate)
    : Math.round(numericPrice * conversionRate * multiplier) / multiplier;
};


export const formatToCents = value => {
  value = (value + '').replace(/[^\d.-]/g, '')
  if (value && value.includes('.')) {
    value = value.substring(0, value.indexOf('.') + 3)
  }

  return value ? Math.round(parseFloat(value) * 100) : 0
}
